module.exports = __webpack_public_path__ + "img/bungalow.b116d252.svg";